import { render } from "./IRRSingleHeatmap.vue?vue&type=template&id=c112e09a"
import script from "./IRRSingleHeatmap.vue?vue&type=script&lang=js"
export * from "./IRRSingleHeatmap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__